import template from './clientAuthorizations.html';
import controller from './clientAuthorizations.controller';
import './clientAuthorizations.less';

let clientAuthorizationsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default clientAuthorizationsComponent;



// WEBPACK FOOTER //
// ./src/app/pages/clientAuthorizations/clientAuthorizations.component.js